import { createContext, useContext, useMemo } from 'react';

const EntryFormContext = createContext();

export const EntryFormProvider = ({ children, value }) => {
  const contextValue = useMemo(
    () => ({
      ...value,
      formMethods: {
        setFieldValue: value.form.setFieldValue,
        handleChange: value.form.handleChange,
        handleBlur: value.form.handleBlur,
        resetForm: value.form.resetForm,
      },
      formValues: value.form.values,
      formErrors: value.form.errors,
      formTouched: value.form.touched,
    }),
    [
      value.form.values,
      value.form.errors,
      value.form.touched,
      value.form.setFieldValue,
      value.form.handleChange,
      value.form.handleBlur,
      value.form.resetForm,
      value.entryTypeIndex,
      value.hallIndex,
      value.halls,
      value.allClients,
      value.allCoaches,
      value.currentLocationGroups,
      value.isEditing,
      value.currentDate,
    ]
  );

  return <EntryFormContext.Provider value={contextValue}>{children}</EntryFormContext.Provider>;
};

export const useEntryFormContext = () => {
  const context = useContext(EntryFormContext);
  if (!context) {
    throw new Error('useEntryFormContext must be used within EntryFormProvider');
  }
  return context;
};
